export default function (state, {data, form}) {
    state.xml = data.ExportReportUrlXml+form;
    state.xlsx = data.ExportReportUrlXlsx+form;
}